import { Box, Typography } from '@mui/material'
// import React from 'react'
import { ColorProps } from '../../utils/theme/colors'
import { Assignment, ViewWeek } from '@mui/icons-material'
import { useQeustion } from '../../context/QuestionContext/QuestionContext'

const QuestionHeader = ({ minutes, seconds, showTimer = true }) => {
  const question = useQeustion()

  const isIST = ['intelligenz-struktur-test (ist)', 'ist'].includes(
    question?.moduleName?.trim().toLowerCase(),
  )

  const isKraep = ['kraepelin test', 'kraepelin'].includes(
    question?.moduleName?.trim().toLowerCase(),
  )

  return (
    <Box bgcolor={'#9AA5EA'} mx={'-1rem'}>
      <Typography textAlign={'center'} fontWeight={700} color={'white'}>
        {showTimer && `${minutes} : ${seconds}`}
      </Typography>
      <Box display={'flex'} px={1} py={2} alignItems={'center'} bgcolor={'#9AA5EA'}>
        <Box>
          {!isIST && !isKraep ? (
            <>
              <Box
                sx={{
                  borderRadius: '24px',
                  backgroundColor: 'white',
                  color: ColorProps['text.1'].light,
                  display: 'flex',
                  alignItems: 'center',
                  p: 1,
                }}
              >
                <Assignment fontSize="smal" />
                <Typography ml={1}>
                  {question.current}/{question.totalQuestion}
                </Typography>
              </Box>
            </>
          ) : (
            showTimer &&
            !isKraep && (
              <>
                <Box
                  sx={{
                    borderRadius: '24px',
                    backgroundColor: 'white',
                    color: ColorProps['text.1'].light,
                    display: 'flex',
                    alignItems: 'center',
                    p: 1,
                  }}
                >
                  <Assignment fontSize="smal" />
                  <Typography ml={1}>
                    {question.currentGlobal || question.current}/{question.totalQuestion}
                  </Typography>
                </Box>
              </>
            )
          )}
          {isKraep && (
            <>
              <Box
                sx={{
                  borderRadius: '24px',
                  backgroundColor: 'white',
                  color: ColorProps['text.1'].light,
                  display: 'flex',
                  alignItems: 'center',
                  p: 1,
                }}
              >
                <Assignment fontSize="smal" />
                <Typography ml={1}>
                  {question.current}/{question?.questionsList?.length}
                </Typography>
              </Box>
              <Box
                sx={{
                  borderRadius: '24px',
                  backgroundColor: 'white',
                  color: ColorProps['text.1'].light,
                  display: 'flex',
                  alignItems: 'center',
                  p: 1,
                  mt: 1,
                }}
              >
                <ViewWeek fontSize="smal" />
                <Typography ml={1}>
                  {question?.questionsList[0]?.type_soal?.replace(/b/g, '')?.trim() || ''}/50
                </Typography>
              </Box>
            </>
          )}
        </Box>
        <Box width={'100%'}>
          <Typography textAlign={'center'} color={'white'} fontWeight={700} fontSize={'16px'}>
            {question.moduleName}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default QuestionHeader
